import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import api from '../../api';
import { RootState } from "../../store";
import { generatePublicApiTokenUrl } from "../../config";

const GENERATE_TOKEN = "generatePublicApiToken";

export type TokenExpiryOption = "six months" | "one year" | "three years" | "five years" | "never";

interface IGeneratePublicApiTokenPayload {
  tokenName: string;
  email: string;
  orgId: string;
  groupId: string;
  expiresAt: TokenExpiryOption;
}

interface IGeneratePublicApiTokenResponse {
  token: any;
  message: any;
}

interface IGeneratePublicApiTokenState {
  status: string;
  error: string | null;
  token: string | null;
  msg: string | null ;
}

const initialState: IGeneratePublicApiTokenState = {
  status: Status.IDLE,
  error: null,
  token: null,
  msg: null,
};

export const generatePublicApiToken = createAsyncThunk(
    GENERATE_TOKEN,
    async (payload: IGeneratePublicApiTokenPayload, { rejectWithValue }) => {
      try {
        const response = await api.post<IGeneratePublicApiTokenResponse>(generatePublicApiTokenUrl, payload);
        return response.data;
      } catch (error) {
        throw rejectWithValue(error);
      }
    }
  );
  
  const generatePublicApiTokenSlice = createSlice({
    name: GENERATE_TOKEN,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(generatePublicApiToken.pending, (state) => {
          state.status = Status.PENDING;
          state.msg = null;
          state.token = null;
        })
        .addCase(generatePublicApiToken.fulfilled, (state, action) => {
          state.status = Status.SUCCESS;
          state.token = action.payload.token;
          state.msg = action.payload.message;
        })
        .addCase(generatePublicApiToken.rejected, (state, action) => {
          const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
          state.status = Status.FAILED;
          state.error = action?.error?.message;
          state.msg = errorPayload?.response?.data?.error?.message || errorPayload?.response?.data?.message || 'Unknown error occurred';
        });
    },
  });
  
  export const selector = (state: RootState) => state.createPublicAPIToken;
  
  export default generatePublicApiTokenSlice.reducer;